import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { FeatureFlagsService } from '../services/feature-flags.service';

/**
 * Guard que valida si una ruta está habilitada según los feature flags
 * Si el flag está deshabilitado, redirige silenciosamente a home sin mostrar notificación
 * 
 * Uso en rutas:
 * {
 *   path: 'media',
 *   loadChildren: () => import('./modules/multimedia/multimedia.module').then(m => m.MultimediaModule),
 *   canActivate: [...otherGuards, FeatureFlagsGuard],
 *   data: { featureFlag: 'MEDIA' }
 * }
 */
@Injectable({
  providedIn: 'root'
})
export class FeatureFlagsGuard implements CanActivate {

  constructor(
    private router: Router,
    private featureFlagsService: FeatureFlagsService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    const featureFlag = route.data['featureFlag'] as string;

    // Si no hay featureFlag especificado, permitir acceso
    if (!featureFlag) {
      return true;
    }

    // Verificar si el feature flag está habilitado
    if (this.featureFlagsService.isFeatureEnabled(featureFlag)) {
      return true;
    }

    // Feature flag deshabilitado - redirigir a coming-soon
    return this.router.createUrlTree(['/coming-soon']);
  }
}
